import { useLocalization } from "@fluent/react";
import { Button } from "@narmi/design_system";
import Filters from "byzantine/src/filters";
import { REVERSAL_REASON_LABELS } from "byzantine/src/dbbl/businessLogic/modules/achPayments";
import type { ReversalReason } from "byzantine/src/dbbl/businessLogic/modules/achPayments";
import styles from "../../DualApproval.module.scss";
import type { TopCardProps } from "./types";

const ReversalDetails = ({
  dualApproval,
  handleClickOriginalPayment,
}: TopCardProps) => {
  const { l10n } = useLocalization();

  return (
    <>
      <h5 className={styles.drawerLabelHeading}>
        {l10n.getString("label-approval-due-date")}
      </h5>
      <div className="margin--bottom--m">
        {dualApproval.expiredAt
          ? Filters.longMonthDayYear(dualApproval.expiredAt)
          : "—"}
      </div>
      <h5 className={styles.drawerLabelHeading}>
        {l10n.getString("label-reversal-reason")}
      </h5>
      <div className="margin--bottom--m">
        {dualApproval.payment?.reversalReason
          ? REVERSAL_REASON_LABELS[
              dualApproval.payment.reversalReason as ReversalReason
            ] || dualApproval.payment.reversalReason
          : "—"}
      </div>
      <h5 className={styles.drawerLabelHeading}>
        {l10n.getString("label-original-payment")}
      </h5>
      <Button
        kind="plain"
        size="s"
        onClick={handleClickOriginalPayment}
        disabled={!handleClickOriginalPayment}
        testId="view-original-payment"
      >
        {l10n.getString("view-original-payment-cta")}
        <span className="narmi-icon-chevron-right" />
      </Button>
    </>
  );
};

export default ReversalDetails;
